import * as request from "@/utils/request";
import { QueryDataRes, PdfInfoReq, StatementListResponse } from "./types";
import { DefaultConfigs, inApp } from "@/common/js/constant";
import { trackEvent } from "@/utils/omega";
import { RISK_SDK_VERSION } from "@/components/RiskVerify/constants";
import BusinessVerify, { EnumBusinessFlow } from "@/components/BusinessVerify";
import UnoBusinessVerify from "@/components/BusinessVerify/UnoBusinessVerify";
import type { RiskVerifyUiVariant } from "@/components/RiskVerify/types";
import APP from "@/utils/app";
import { setCommonAttrs } from "@didi/x-tracker";
import { statementListMock } from "./mock";

const baseUrl = `${DefaultConfigs.publicAPIPath}`;
const statementListUrl = `${baseUrl}/sofipo/v0/bill/statementList`;

type CycleSelectionServiceOptions = {
  verifyUiVariant?: RiskVerifyUiVariant;
};

const createBusinessVerify = (uiVariant?: RiskVerifyUiVariant) =>
  uiVariant === "uno" ? new UnoBusinessVerify() : new BusinessVerify();

// 获取月度对账单周期列表
export const queryStatementList = async (): Promise<StatementListResponse> => {
  return request.post<StatementListResponse>(statementListUrl, {});
  // void statementListUrl;
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve(statementListMock);
  //   }, 2000);
  // });
};

// 获取银行账单pdf地址

export const queryPdfAddress = async (
  params: PdfInfoReq,
  options: CycleSelectionServiceOptions = {},
): Promise<QueryDataRes> => {
  // 核验版本
  params.verifyInfo = params.verifyInfo || {
    verifySdkVersion: RISK_SDK_VERSION,
  };
  try {
    return await request.post<QueryDataRes>(`${baseUrl}/sofipo/v0/bill/queryPdfAddress`, params);
  } catch (ret: any) {
    // 业务核验
    if (ret.errno === request.ERROR_TYPE.BusinessVerify) {
      // 核验拉起时禁止返回按钮
      if (inApp) {
        APP.requestBackPressedControl(() => {});
      }
      // 设置公参
      setCommonAttrs({
        // scene_source
        // 场景来源
        // 0-风控
        // 1-业务
        scene_source: BusinessVerify.scene,
        // from_source 流程来源
        from_source: EnumBusinessFlow.bankStatement,
      });

      // 拉起核验
      return createBusinessVerify(options.verifyUiVariant)
        .verify(JSON.parse(ret?.data?.bussVerifyResultInfo)?.atoDomain)
        .then((res) => {
          // 重置公参
          setCommonAttrs({
            // scene_source
            // 场景来源
            // 0-风控
            // 1-业务
            scene_source: undefined,
            // from_source 流程来源
            from_source: undefined,
          });
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 增加核验token
          if (params.verifyInfo) {
            params.verifyInfo.sessionId = res.verify_session_id;
            // 核验完成
            params.verifyInfo.bussVerify = 1;
            params.sessionId = res.verify_session_id;
          }
          // 重新发起请求
          return queryPdfAddress(params, options);
        })
        .catch((err) => {
          // 释放控制
          if (inApp) {
            APP.cancelBackPressedControl();
          }
          // 技术打点
          trackEvent("tech_sofi_catch_error", {
            source: "bankstatement.cycleSelect.BusinessVerify",
            data: JSON.stringify(ret.name + ret.message || ret),
          });
          // 交给上层catch
          return Promise.reject(err);
        });
    }
    // 释放控制
    if (inApp) {
      APP.cancelBackPressedControl();
    }

    // 技术打点
    trackEvent("tech_sofi_catch_error", {
      source: "bankstatement.cycleSelect.queryPdfAddress",
      data: JSON.stringify(ret.name + ret.message || ret),
    });

    // 交给上层catch
    return Promise.reject(ret);
  }
};
